export default __webpack_public_path__ + "assets/earn-more-money.34d03f06.svg";